export function propDescriptionReadMore() {
  let description = document.querySelector(
    "#description-title .property_description"
  );
  if (!description) return;
  if (description.getBoundingClientRect().height < 320) return;

  // create a node to hold the read more link

  let readMoreLink = document.createElement("a");
  readMoreLink.classList.add("read-more-link");
  readMoreLink.setAttribute("href", "#");
  readMoreLink.innerHTML = "Read More&hellip;";
  let readMore = document.createElement("p");
  readMore.classList.add("read-more");
  readMore.appendChild(readMoreLink);
  description.appendChild(readMore);

  description.dataset.expanded = false;

  readMoreLink.addEventListener("click", function (e) {
    console.log(e.target);
    e.preventDefault();
    toggle_read_more();
  });
}
export function toggle_read_more() {
  let description = document.querySelector(
    "#description-title .property_description"
  );
  let readMoreLink = document.querySelector(
    "#description-title .read-more-link"
  );
  if ("true" === description.dataset.expanded) {
    description.dataset.expanded = "false";
    readMoreLink.innerHTML = "Read More&hellip;";
  } else {
    description.dataset.expanded = "true";
    readMoreLink.innerHTML = "Read Less&hellip;";
  }
}
